"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadMROAuth = loadMROAuth;
let mrPromise;
/**
 * Выполняет асинхронную загрузку Mail.Ru OAuth API
 */
function loadMROAuth() {
  if (!mrPromise) {
    mrPromise = new Promise((resolve, reject) => {
      if (window.MR) {
        resolve(window.MR);
        return;
      }
      const element = document.createElement('script');
      element.src = 'https://oauth.mail.ru/sdk/v0.12.0/oauth.js';
      element.async = true;
      element.defer = true;
      element.onload = () => {
        resolve(window.MR);
      };
      element.onerror = () => {
        reject(new Error('Unable to load Mail.Ru OAuth API'));
      };
      document.body.appendChild(element);
    });
  }
  return mrPromise;
}